import { atom, selector } from "recoil"

import type { Cursor } from "~/containers/LegacyDesigner/Studio/Elements/CURSORS"

import { toolState } from "../../tool"
import { edgeDesignationState } from "../../tool/edgeDesignation"
import { activePanelIndex, hoveredPanelState } from "../panels"

export const mouseHeldInStudioState = atom<boolean>({
  key: `mouseHeldInStudio`,
  default: false,
})

export const cursorState = selector<Cursor>({
  key: `designToolCursorSelector`,
  get: ({ get }) => {
    const tool = get(toolState)
    const edgeDesignation = get(edgeDesignationState)
    const mouseHeld = get(mouseHeldInStudioState)
    const hoveredPanelId = get(hoveredPanelState)
    const activePanels = get(activePanelIndex)
    const hoveredPanelIsActive = activePanels.includes(hoveredPanelId)

    switch (tool) {
      case `Select`:
        return `Select`
      case `Draw`:
        return `Pen`
      case `Pan`:
        return mouseHeld ? `Pan_Grab` : `Pan`
      case `Erase`:
        return `Erase`
      case `Move`:
        return `Move_All`
      case `PanelCreatorPortrait`:
        return `Panel_Place`
      case `PanelCreatorLandscape`:
        return `Panel_Place`
      case `PanelEraser`:
        return `Panel_Erase`
      case `PanelActivator`:
        return hoveredPanelIsActive ? `Panel_Minus` : `Panel_Plus`
      case `EdgeDesignator`:
        if (edgeDesignation === `eave`) return `Edge_Eave`
        if (edgeDesignation === `hip`) return `Edge_Hip`
        if (edgeDesignation === `rake`) return `Edge_Rake`
        if (edgeDesignation === `ridge`) return `Edge_Ridge`
        if (edgeDesignation === `valley`) return `Edge_Valley`

        return `Edge_Black`
      default:
        return `Select`
    }
  },
})
